import React from 'react';
import { AnimationOnScroll } from 'react-animation-on-scroll';
import SEOFeaturesData from '../../data/seo/SEOFeatures.json';
import SectionTitle from '../../elements/section-title/SectionTitle';

const SEOBestForYouSection = () => {
    const stepColors = [
        '#4FC3F7', // Blue - Discovery & Audit
        '#FFB74D', // Orange - Strategy Development
        '#E57373', // Pink/Red - Execution
        '#66BB6A', // Green - Monitoring & Optimization
        '#9575CD'  // Purple - Reporting & Growth
    ];

    return (
        <div className="section section-padding seo-best-for-you-section">
            {/* Background Shapes */}
            {/* <div className="shape-wrapper shape-1">
                <img
                    src={process.env.PUBLIC_URL + "/images/others/circle-shape.png"}
                    alt="Shape"
                    className="shape-image"
                />
            </div> */}
            <div className="shape-wrapper shape-2">
                <img
                    src={process.env.PUBLIC_URL + "/images/others/line-2.png"}
                    alt="Shape"
                    className="shape-image"
                />
            </div>

            <div className="container">
                <SectionTitle
                    subtitle="Our Process"
                    title="Best For You"
                    textAlignment="title heading-center mb--40"
                    textColor=""
                    paragraphClass="d-none"
                />
                <div className="bfy-inner">
                    {/* Left Side - Image */}
                    <div className="d-flex col-lg-6 col-md-12 mb-5 mb-lg-0 align-items-center justify-content-center">
                        <AnimationOnScroll animateIn="fadeInLeft" animateOnce={true}>
                            <div className="seo-image-wrapper">
                                <img
                                    src={process.env.PUBLIC_URL + "/images/banner/SEO-best-for-you.png"}
                                    alt="Best For You Process"
                                    className="seo-process-image"
                                />
                            </div>
                        </AnimationOnScroll>
                    </div>

                    {/* Right Side - Process Steps */}
                    <div className="col-lg-6 col-md-12">
                        <AnimationOnScroll animateIn="fadeInRight" animateOnce={true}>
                            <div className="seo-steps-wrapper">
                                {/* Process Steps */}
                                <div className="seo-steps-container">
                                    {SEOFeaturesData.map((feature, index) => (
                                        <div className="seo-step-item" key={index}>
                                            <div className="seo-step-number-wrapper">
                                                <div
                                                    className="seo-step-number-diamond"
                                                    style={{ backgroundColor: stepColors[index] }}
                                                >
                                                    <span>{index + 1}</span>
                                                </div>
                                                {index < SEOFeaturesData.length - 1 && (
                                                    <div className="seo-step-connector"></div>
                                                )}
                                            </div>
                                            <div className="seo-step-content">
                                                <h5 className="seo-step-title">{feature.title}</h5>
                                                <p className="seo-step-description">{feature.description}</p>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </AnimationOnScroll>
                    </div>
                </div>
            </div>

            <style jsx>{`
                .seo-best-for-you-section {
                    background-color: #ffffff;
                    position: relative;
                    overflow: hidden;
                    padding: 0 0 110px;
                }

                /* Background Shapes */
                .shape-wrapper {
                    position: absolute;
                    z-index: 0;
                    pointer-events: none;
                }

                .seo-best-for-you-section shape-1 {
                    top: 50px;
                    right: 0;
                    width: 300px;
                    opacity: 0.15;
                }

                .seo-best-for-you-section .shape-2 {
                    bottom: 80px;
                    left: -50px;
                    width: 400px;
                    opacity: 0.1;
                }

                .shape-image {
                    width: 100%;
                    height: auto;
                }
                
                .bfy-inner {
                    display: flex;
                    flex-direction: row;
                    align-items: center;
                }
                
                .seo-image-wrapper {
                    position: relative;
                    width: 100%;
                    max-width: 550px;
                    margin: 0 auto;
                }
                
                .seo-process-image {
                    width: 100%;
                    height: auto;
                    object-fit: contain;
                }
                
                .seo-steps-wrapper {
                    position: relative;
                    padding-left: 30px;
                }
                
                .seo-steps-container {
                    margin-top: 0;
                }
                
                .seo-step-item {
                    display: flex;
                    gap: 25px;
                    margin-bottom: 20px;
                    position: relative;
                }
                
                .seo-step-item:last-child {
                    margin-bottom: 0;
                }
                
                .seo-step-number-wrapper {
                    position: relative;
                    flex-shrink: 0;
                    margin-inline: 28px;
                }
                
                .seo-step-number-diamond {
                    width: 40px;
                    height: 40px;
                    transform: rotate(45deg);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    position: relative;
                    z-index: 1;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.15);
                }
                
                .seo-step-number-diamond::before {
                    content: '';
                    position: absolute;
                    inset: -8px;
                    background: inherit;
                    opacity: 0.2;
                    border-radius: 2px;
                }
                
                .seo-step-number-diamond span {
                    transform: rotate(-45deg);
                    font-size: 24px;
                    font-weight: 700;
                    color: #ffffff;
                }
                
                .seo-step-connector {
                    position: absolute;
                    left: 50%;
                    top: 65px;
                    transform: translateX(-50%);
                    width: 2px;
                    height: 60px;
                    background-image: repeating-linear-gradient(
                        to bottom,
                        #ddd 0,
                        #ddd 6px,
                        transparent 6px,
                        transparent 12px
                    );
                    z-index: 0;
                }
                
                .seo-step-content {
                    flex: 1;
                    padding-top: 8px;
                }
                
                .seo-step-title {
                    color: #1a1a1a;
                    font-size: 22px;
                    font-weight: 600;
                    margin-bottom: 10px;
                    line-height: 1.3;
                }
                
                .seo-step-description {
                    color: #666;
                    font-size: 15px;
                    line-height: 1.7;
                    margin-bottom: 0;
                }
                
                /* Responsive Styles */
                @media (max-width: 991px) {
                    .bfy-inner {
                        flex-direction: column;
                    }
                    
                    .seo-best-for-you-section {
                        padding: 60px 0 60px;
                    }
                    
                    .seo-steps-wrapper {
                        padding-left: 0;
                        margin-top: 40px;
                    }
                    
                    .seo-steps-container {
                        margin-top: 0;
                    }
                    
                    .seo-image-wrapper {
                        max-width: 450px;
                    }

                    .seo-best-for-you-section .shape-1 {
                        width: 200px;
                        top: 30px;
                    }

                    .seo-best-for-you-section .shape-2 {
                        width: 300px;
                        left: -30px;
                    }
                }
                
                @media (max-width: 767px) {
                    .seo-step-number-diamond {
                        width: 30px;
                        height: 30px;
                    }
                    
                    .seo-step-number-diamond span {
                        font-size: 18px;
                    }
                    
                    .seo-step-connector {
                        top: 55px;
                        height: 50px;
                    }
                    
                    .seo-step-title {
                        font-size: 20px;
                    }
                    
                    .seo-step-description {
                        font-size: 14px;
                    }
                    
                    .seo-step-item {
                        gap: 20px;
                        margin-bottom: 15px;
                    }

                    .seo-best-for-you-section .shape-1 {
                        width: 150px;
                    }

                    .seo-best-for-you-section .shape-2 {
                        width: 250px;
                        opacity: 0.08;
                    }
                }
                
                @media (max-width: 575px) {
                    .seo-step-number-diamond {
                        width: 40px;
                        height: 40px;
                    }
                    
                    .seo-step-number-diamond span {
                        font-size: 18px;
                    }
                    
                    .seo-step-item {
                        gap: 15px;
                        margin-bottom: 15px;
                    }
                    
                    .seo-step-title {
                        font-size: 18px;
                    }

                    .seo-best-for-you-section .shape-1,
                    .seo-best-for-you-section .shape-2 {
                        display: none;
                    }
                }
            `}</style>
        </div>
    );
};

export default SEOBestForYouSection;